import { useTranslation } from "next-i18next"

import TalkToVoxme from "../../components/TalkToVoxme"
import Skeleton from "@mui/material/Skeleton"
import Style from "./HomeMainButtons.module.scss"

import useUser from "../../hooks/useUser"

export default function HomeMainButtons() {
  const { t } = useTranslation("common")
  const { status } = useUser()

  return (
    <div className={Style.Wrapper}>
      <div className={Style.HeroVideoAndCTA}>
        {status === "loading" ? (
          <Skeleton
            variant="rounded"
            style={{ borderRadius: "20px" }}
            className="mr-5"
            width={400}
            height={55}
          />
        ) : (
          <TalkToVoxme />
        )}
      </div>
      <div className={Style.NoCardCreditRequired}>
        {t("COMMON_NO_PAYMENT_REQUIRED")}
      </div>
    </div>
  )
}
